import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("TRADE_REQUESTS");
const CRUD_ACTION_HANDLERS = getActionHandler("TRADE_REQUESTS");

export default function tradeRequests(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
